import { useState, useEffect, useRef } from 'react';
import { SocialLinks } from './SocialLinks';

export function ShareModal({ shareLink, isOpen, onClose }) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  const handleCopy = async () => {
    try {
      if (!shareLink) return;
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      timeoutRef.current = window.setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const cloneCanvas = (source) => {
    if (!source) return;
    const dataURL = source.toDataURL();
    const newImage = new Image();
    // 3. Set the Image source to the Data URL
    newImage.src = dataURL;
    const finalDesign = document.getElementById('customizer-final-design');
    if (finalDesign) {
      finalDesign.innerHTML = '';
      finalDesign.appendChild(newImage);
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      cloneCanvas(
        document.querySelector('#customizer-main-perspective canvas')
      );
    }
  }, [isOpen]);

  return (
    <div
      id="share-link"
      className={`${isOpen ? 'flex' : 'hidden'} px-[16px] md:px-0`}
    >
      <div className="flex flex-col gap-[16px] size-full bg-white relative z-0 rounded-[10px]">
        <button
          type="button"
          id="share-closed"
          className="absolute top-[16px] right-[16px] cursor-pointer z-10"
          aria-label="Close share modal"
          tabIndex={0}
          onClick={onClose}
        >
          ✕
        </button>
        <div id="customizer-final-design" />
        <div className="flex flex-col gap-[16px] px-[24px] pb-[24px]">
          <h2>Share Your Design</h2>
          <div className="share-items">
            <div className="shareable-link">
              <p id="customizer-share-link">{shareLink}</p>
            </div>
            <SocialLinks shareLink={shareLink} />
            <button
              type="button"
              id="copy-button"
              className="button"
              aria-label="Copy share link"
              tabIndex={0}
              onClick={handleCopy}
            >
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
